import i18n from '@/i18n';

export const STATUS_AVAILABLE = 'a';
export const STATUS_VACATION = 'v';
export const STATUS_LEAVING = 'l';
export const STATUS_MOVED = 'm';
export const STATUS_ILL = 'i';

// crm additional statuses
export const STATUS_NEGATIVE = 'n';
export const STATUS_LOST = 'p';
export const STATUS_FIRE = 'f';
export const STATUS_BUSY = 'b';

export const STATUS_INFO = {
  [STATUS_AVAILABLE]: {
    color: '#4CAF50',
    label: i18n.t('scheduler.statuses.available'),
    value: 'a'
  },
  [STATUS_VACATION]: {
    color: '#03A9F4',
    label: i18n.t('scheduler.statuses.vacation'),
    value: 'v'
  },
  [STATUS_LEAVING]: {
    color: '#9C27B0',
    label: i18n.t('scheduler.statuses.leaves'),
    value: 'l'
  },
  [STATUS_MOVED]: {
    color: '#009688',
    label: i18n.t('scheduler.statuses.move_day'),
    value: 'm'
  },
  [STATUS_ILL]: {
    color: '#FFD600',
    label: i18n.t('scheduler.statuses.illness'),
    value: 'i'
  },
  [STATUS_NEGATIVE]: {
    color: '#D50000',
    label: i18n.t('scheduler.statuses.negative'),
    value: 'n'
  },
  [STATUS_LOST]: {
    color: '#E91E63',
    label: i18n.t('scheduler.statuses.disappeared'),
    value: 'p'
  },
  [STATUS_FIRE]: {
    color: '#757575',
    label: i18n.t('scheduler.statuses.kick_out'),
    value: 'f'
  },
  [STATUS_BUSY]: {
    color: '#424242',
    label: i18n.t('scheduler.statuses.busy'),
    value: 'b'
  },
};
